import { useTranslation } from "react-i18next";
import { WarningOutlined } from "@ant-design/icons";
import { Alert, Button, Modal, Typography } from "antd";

const { Paragraph, Title } = Typography;

interface Props {
  open: boolean;
  planName: string;
  violations: string[];
  onClose: () => void;
}

export const SubscriptionConformanceModal = ({
  open,
  planName,
  violations,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const labelsByViolation = new Map<string, string>([
    ["resource_limit", t("subscription.conformanceCollectors")],
    ["tracker", t("subscription.conformanceTrackers")],
    ["user_limit", t("subscription.conformanceUsers")],
    ["storage_limit", t("subscription.conformanceStorage")],
    ["permissions", t("subscription.conformancePrivate")],
  ]);
  const violationLabels = [
    ...new Set(
      violations.map(
        (violation) => labelsByViolation.get(violation) ?? violation,
      ),
    ),
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      footer={
        <Button type="primary" onClick={onClose}>
          {t("team.ok")}
        </Button>
      }
    >
      <div style={{ marginBottom: 12 }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
          }}
        >
          <WarningOutlined
            style={{
              color: "#8A5A00",
              flexShrink: 0,
              fontSize: 22,
              marginTop: 2,
            }}
          />
          <Title level={4} style={{ margin: 0 }}>
            {t("subscription.conformanceTitle")}
          </Title>
        </div>
        <Paragraph
          type="secondary"
          style={{ margin: "4px 0 0", textAlign: "left" }}
        >
          {t("subscription.conformanceMessage", { plan: planName })}
        </Paragraph>
      </div>

      {violationLabels.length > 0 && (
        <Alert
          type="warning"
          styles={{
            root: {
              background: "#FFF2D6",
              border: "1px solid #8A5A0059",
            },
          }}
          title={
            <ul
              style={{
                color: "#8A5A00",
                margin: 0,
                paddingLeft: 20,
                textAlign: "left",
              }}
            >
              {violationLabels.map((label) => (
                <li key={label}>{label}</li>
              ))}
            </ul>
          }
        />
      )}

      <Paragraph type="secondary" style={{ margin: "16px 0 0" }}>
        {t("subscription.conformanceAction")}
      </Paragraph>
    </Modal>
  );
};
